(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ap-keys', {
            parent: 'account',
            url: '/ap-keys',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.settings.api.keys'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/ap-keys/ap-keys-list/ap-keys.html',
                    controller: 'ApiKeysController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('api.keys');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('client');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
